<template>
  <v-layout >
    <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
      <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
        <v-btn icon @click="cancelDialogEdit()"><v-icon class="white--text">close</v-icon></v-btn>
        <div class="title tf_title_dialog">{{ intentDialog.code }}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="confirmeDialogEdit()" class="white--text">{{ $t('submit') }}</v-btn>
      </v-card-title>

      <v-tabs
        v-model="currentTab"

        left
        slider-color="secondary"
      >
        <v-tab
          v-for="tab of tabs"
          :key="tab.index"

        >
          <v-icon class="primary--text">{{tab.icone}}</v-icon>
          {{tab.name}}
        </v-tab>

        <v-tab-item :key="'tab_fiche'" style="overflow: auto;">
          <!-- Chargement -->
          <div v-if="loading" class="text-xs-center" style="min-height: 160px;">
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </div>
          <v-card-text v-else :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 300px);' : ''">

              <v-layout row wrap>

                <!-- infos lead -->
                <v-flex xs12 md4>
                  <v-card-text>
                    <p>
                      <span class='body-1 font-italic'>{{$t('dateMessage')}}</span><br>
                      <span class='body-2 font-weight-bold'>{{intentDialog.date}}</span>
                    </p>
                    <p v-if="modeExpert">
                      <span class='body-1 font-italic'>{{$t('codeIntent')}}</span><br>
                      <span class='body-2 font-weight-bold'>{{actualIntent}}</span>
                    </p>
                    <p v-if="modeExpert">
                      <span class='body-1 font-italic'>{{$t('numIntent')}}</span><br>
                      <span class='body-2 font-weight-bold'>{{intentDialog.nb}}</span>
                    </p>
                    <p v-if="modeExpert">
                      <span class='body-1 font-italic'>{{$t('idConv')}}</span><br>
                      <span class='body-2 font-weight-bold'>{{intentDialog.convid}}</span>
                    </p>

                    <v-alert
                      v-if="activeIntents >= limiteMaxIntents"
                      :value="true"
                      color="warning"
                      icon="priority_high"
                      outline
                    >
                      {{$t('limitConn')}}
                    </v-alert>

                  </v-card-text>
                </v-flex>
                <v-spacer></v-spacer>

                <!-- Choix/création de l'intention -->
                <v-flex xs12 md8>
                  <v-container>

                    <v-timeline
                      dense
                      align-top
                    >

                      <v-timeline-item
                        large
                        right
                        color="#A3CDEE"
                      >
                        <template v-slot:icon class='tf-icone'>
                          <v-icon color="white">person</v-icon>
                        </template>
                        <template v-slot:opposite>
                          <span>{{intentDialog.data}}</span>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs9 class="caption font-italic">{{$t('messageInternaute')}}</v-flex>
                          <v-flex xs3 text-xs-right class="caption font-italic">{{intentDialog.date}}</v-flex>
                        </v-layout>
                        <v-card class="elevation-4" color="#f0f8ff">
                          <v-card-text class="body-2 font-weight-medium">
                            {{intentDialog.code}}
                          </v-card-text>
                        </v-card>
                      </v-timeline-item>

                      <v-timeline-item
                        v-if="intentDialog.intent != ''"
                        large
                        right
                        color="light-green lighten-1"
                      >
                        <template v-slot:icon>
                          <v-icon color="white">mediation</v-icon>
                        </template>
                        <template v-slot:opposite>
                          <span>{{intentDialog.data}}</span>
                        </template>
                        <v-flex xs9 class="caption font-italic">{{$t('baseConnRecon')}} <span class='caption font-weight-bold'>{{findDescIntent}}</span></v-flex>
                        <v-card class="elevation-4">
                          <v-card-actions @click="showIntent = !showIntent" class='btnIntentBot'>
                            <v-btn small flat icon color="light-green lighten-1">
                              <v-icon>{{ showIntent ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                            </v-btn>
                            <span class="pl-2">{{$t('modifConn')}}</span>
                          </v-card-actions>
                          
                          <v-slide-y-transition>
                            <v-card-text v-show="showIntent" class="body-2 font-weight-medium">
                              <v-autocomplete
                                :loading="isLoading"
                                :search-input.sync="search"
                                v-model="changeIntent"
                                :hint="intentDialog.intent === '' ? $t('choixConnExist') : $t('choixConnList')"
                                :items="listIntents"
                                :label="$t('selectConn')"
                                :disabled="blockSelector"
                                allow-overflow
                                persistent-hint
                                return-object
                              >
                              </v-autocomplete>
                            </v-card-text>
                          </v-slide-y-transition>

                          <v-card-actions v-if="showIntent && activeIntents < limiteMaxIntents"  class='btnIntentBot' @click="showDialogCreateIntent = true">
                            <v-btn small icon color="secondary" >
                              <v-icon>add</v-icon>
                            </v-btn>
                            <span class="pl-2">{{$t('creatConn')}}</span>
                          </v-card-actions>
                        </v-card>
                      </v-timeline-item>

                      <v-timeline-item
                        v-else
                        large
                        right
                        color="amber lighten-2"
                      >
                        <template v-slot:icon>
                          <v-icon color="white">report_problem</v-icon>
                        </template>
                        <template v-slot:opposite>
                          <span>{{intentDialog.data}}</span>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs9 v-if="botReponses == 'null'" class="caption font-italic">{{$t('aucunConn')}}</v-flex>
                          <v-flex xs9 v-else class="caption font-italic">{{actualIntent}}</v-flex>
                        </v-layout>
                        <v-card class="elevation-4">
                          <v-card-text v-if="botReponses == 'null'" v-show="showIntent" class="body-2 font-weight-medium">
                          </v-card-text>

                          <v-card-actions  @click="showIntent = !showIntent" class='btnIntentBot'>
                            <v-btn small flat icon color="light-green lighten-1">
                              <v-icon>{{ showIntent ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                            </v-btn>
                            <span class="pl-2">{{botReponses == 'null' ? $t('addConn') : $t('modifConn')}}</span>
                          </v-card-actions>
                          
                          <v-slide-y-transition>
                            <v-card-text v-show="showIntent" class="body-2 font-weight-medium">
                              <v-autocomplete
                                :loading="isLoading"
                                :search-input.sync="search"
                                v-model="changeIntent"
                                :hint="intentDialog.intent === '' ? $t('choixConnExist') : $t('choixConnList')"
                                :items="listIntents"
                                :label="$t('selectConn')"
                                :disabled="blockSelector"
                                allow-overflow
                                persistent-hint
                                return-object
                              >
                              </v-autocomplete>
                            </v-card-text>
                          </v-slide-y-transition>

                          <v-card-actions v-if="showIntent && activeIntents < limiteMaxIntents"  class='btnIntentBot' @click="showDialogCreateIntent = true">
                            <v-btn small icon color="secondary" >
                              <v-icon>add</v-icon>
                            </v-btn>
                            <span class="pl-2">{{$t('creatConn')}}</span>
                          </v-card-actions>

                        </v-card>
                      </v-timeline-item>

                    <div v-if="repBotRandom">
                      <v-timeline-item
                        v-for="rep in reponseRandom"
                        :key="rep"
                        large
                        right
                        color="#1F89C6"
                      >
                        <template v-slot:icon>
                          <v-icon v-if="reponseRandom == 'null'" color="white">smart_toy</v-icon>
                          <v-icon v-else color="white">smart_toy</v-icon>
                        </template>
                        <template v-slot:opposite>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs9 v-if="reponseRandom == 'null'" class="caption font-italic">{{$t('aucunReponseBot')}}</v-flex>
                          <v-flex xs9 v-else class="caption font-italic">{{$t('aleatoirReponseBot')}}</v-flex>
                        </v-layout>

                        <v-card
                          v-if="reponseRandom == 'null'"
                          class="elevation-4" color="#8fcbed"
                        >
                        <v-card-text class="body-2 font-weight-medium">...</v-card-text>
                        </v-card>
                        
                        <v-card
                          v-else
                          class="elevation-4" color="#8fcbed"
                        >
                          <v-card-text v-html="rep" class="body-2 font-weight-medium">
                          </v-card-text>
                        </v-card>
                      </v-timeline-item>
                    </div>
                    <div v-else>
                      <v-timeline-item
                        v-for="rep in botReponses"
                        :key="rep"
                        large
                        right
                        color="#1F89C6"
                      >
                        <template v-slot:icon>
                          <v-icon v-if="botReponses == 'null'" color="white">smart_toy</v-icon>
                          <v-icon v-else color="white">smart_toy</v-icon>
                        </template>
                        <template v-slot:opposite>
                        </template>
                        <v-layout justify-space-between>
                          <v-flex xs9 v-if="botReponses == 'null'" class="caption font-italic">{{$t('aucunReponseBot')}}</v-flex>
                          <v-flex xs9 v-else class="caption font-italic">{{$t('reponseBot')}}</v-flex>
                        </v-layout>

                        <v-card
                          v-if="botReponses == 'null'"
                          class="elevation-4" color="#8fcbed"
                        >
                        <v-card-text class="body-2 font-weight-medium">...</v-card-text>
                        </v-card>
                        
                        <v-card
                          v-else
                          class="elevation-4" color="#8fcbed"
                        >
                          <v-card-text v-html="rep" class="body-2 font-weight-medium">
                          </v-card-text>
                        </v-card>
                      </v-timeline-item>
                    </div>

                    </v-timeline>

                  </v-container>
                </v-flex>
              </v-layout>

          </v-card-text>
        </v-tab-item>

        <!-- tab conversation -->
        <v-tab-item :key="'tab_chat'">
          <v-card-text :style="!$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : ''" class="pa-0">
            <wz-conv-training-bot
              v-if="intentDialog.convid"
              :params="intentDialog.convid"
              :intentId="intentDialog.id"
              chatHeight="100%"
              type="satisfaction"
              scroll
              @changeSection="changeSection"
              @changeDialogIntent="changeDialogIntent"
            ></wz-conv-training-bot>
          </v-card-text>
        </v-tab-item>

      </v-tabs>

      <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && currentTab == 0">
        <v-spacer></v-spacer>
        <v-btn flat @click="cancelDialogEdit()" v-if="disableValid">Fermer</v-btn>
        <v-btn flat @click="cancelDialogEdit()" v-else>{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" @click="confirmeDialogEdit()" :disabled="disableValid">{{ $t('submit') }}</v-btn>
      </v-card-actions>
    </v-card>

    <!-- DIALOGUE CREATION -->
    <v-dialog
      v-model="showDialogCreateIntent"
      persistent
      max-width="320"
    >
      <wz-new-faq
        :modeExpert="modeExpert"
        :newIntentExemple="newIntentExemple"
        :botWorkspace="intentDialog.botWorkspace"
        @closeDialog="showDialogCreateIntent = false"
        @updateFAQ="updateFAQ"
      ></wz-new-faq>
    </v-dialog>

    <!-- DIALOGUE MODIF -->
    <v-dialog
      v-model="showDialogUpdate"
      persistent
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <wz-faq
        :showDialogUpdate="showDialogUpdate"
        :faqDialog="faqDialog"
        :modeExpert="modeExpert"
        :botWorkspace="intentDialog.botWorkspace"
        :jumps="jumps"
        @closeDialog="showDialogUpdate = false"
        @addRep="addReponses"
        @submitUpdate="submitUpdate"
      ></wz-faq>
    </v-dialog>

    <!-- Dialog confirmation -->
    <!--
    <v-dialog
      v-model="showDialogConfirmation"
      max-width="390"
    >
      <v-layout >
        <v-card flat class="conteneurLead" id="conteneurLead" style="width: 100%;">
          <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
            <v-btn icon @click="showDialogConfirmation = false"><v-icon class="white--text">close</v-icon></v-btn>
            <div class="title tf_title_dialog">Confirmation</div>
            <v-spacer></v-spacer>
            <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialogEdit()" class="white--text">{{ $t('submit') }}</v-btn>
          </v-card-title>
          <v-card-text v-html="contentDialogConfirm"> </v-card-text>
          <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && currentTab == 0">
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogConfirmation = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" @click="submitDialogEdit()">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog> 
    -->
    <!-- Dialog confirmation -->
    <v-dialog
      v-model="showDialogConfirmation"
      scrollable
      max-width="390"
    >
      <wz-dialog-confirm
        :titleDialogConfirm="titleDialogConfirm"
        :contentDialogConfirm="contentDialogConfirm"
        :showDialogConfirmation="showDialogConfirmation"
        :loadingModifFAQ="loadingModifFAQ"
        @closeDialogConfirm="closeDialogConfirm"
        @submitDialogConfirm="submitDialogConfirm"
      ></wz-dialog-confirm>
    </v-dialog> 

  </v-layout>
</template>



<script>
import _ from 'lodash'
export default {
  props: {
    intentDialog: {
      type: Object,
      default: () => ({})
    },
    hideLead: {
      type: Boolean,
      default: false
    },
    modeExpert: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      loadingModifFAQ: false,
      search: null,
      loading: false,
      showIntent: false,
      resAjx: null,
      tabs: [],
      listIntents: [],
      currentTab: 0,
      originalIntent: '',
      intentToCreate: '',
      actualIntent: '-',
      blockSelector: false,
      samples: [],
      changeIntent: '',
      botReponses: '',
      // dialog création new intention
      newIntentExemple: {ex: 'test'},
      faqDialog: {type: '', output1: '', output2: '', output3: ''},
      showDialogCreateIntent: false,
      intents: [],
      activeIntents: 0,
      limiteMaxIntents: 2000,
      repBotRandom: false,
      showDialogConfirmation: false,
      showDialogUpdate: false,
      disableValid: false,
      titleDialogConfirm: '',
      contentDialogConfirm: '',
      jumps: []
    }
  },

  computed: {
    reponseRandom () {
      if (this.repBotRandom) {
        console.log('botReponses', this.botReponses)
        // retourne une des reponses au hazar
        return [this.botReponses[Math.floor(Math.random() * this.botReponses.length)]]
      }
    },
    findDescIntent () {
      // let index = _.findIndex(this.$store.state._Sites.intents, function (o) { return o.code === this.intentDialog.intent })
      let index = this.$store.state._Sites.intents.findIndex(ex => ex.code === this.intentDialog.intent)
      if (index !== -1) {
        return this.$store.state._Sites.intents[index].desc
      }
    }
  },

  mounted () {
    this.tabs = [
      { index: 0, name: this.$t('intentModif'), icone: 'assignment' },
      { index: 1, name: 'Conversation', icone: 'question_answer' }
    ]
    this.afficheReponseBot()
    this.initList()
  },
  updated () {
  },
  methods: {
    cancelDialogEdit () {
      this.$emit('closeDialog')
    },
    clearIntentToCreate () {
      this.intentToCreate = ''
      this.blockSelector = false
    },
    initList () {
      console.log('initList', this.intentDialog.botWorkspace)
      if (!this.intentDialog.botWorkspace || this.intentDialog.botWorkspace === 'undefined') {
        return
      }
      if (!this.$store.state._Sites.intents || this.$store.state._Sites.intents.length === 0) {
        this.loading = true
        this.resAjx = null
        this.listIntents = []

        let dataPost = new window.FormData()
        dataPost.append('botWorkspace', this.intentDialog.botWorkspace)
        this.axios.post('https://public.targetfirst.com/public/ibm/intents.php', dataPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          console.log('initList - response.data', response.data)
          this.resAjx = response.data
          this.$store.commit('_Sites/SET_INTENTS', this.resAjx)
        })
        .then(_ => {
          this.loading = false
          console.log('initList - this.resAjx', this.resAjx)
          for (let n in this.resAjx) {
            let listExamples
            // si il y a une description on la prend sinon on la remplacepar le 1er exemple
            if (this.resAjx[n].desc !== '') {
              listExamples = this.resAjx[n].desc
            } else {
              listExamples = this.resAjx[n].ex[0]
            }
            this.listIntents.push({ listExamples,
              value: this.resAjx[n].code,
              code: this.resAjx[n].code,
              desc: this.resAjx[n].desc,
              ex: this.resAjx[n].ex,
              botWorkspace: this.botWorkspace
            })
          }
          // classement
          // this.listIntents.sort(function (a, b) {
          //   return a.localeCompare(b)
          // })
          this.classementListeIntents()
        })
        .catch()
      } else {
        // console.log('initList - this.$store.state._Sites.intents', this.$store.state._Sites.intents)
        this.loading = false
        this.listIntents = []
        let lesIntents = this.$store.state._Sites.intents
        for (let n in lesIntents) {
          let listExamples
          // si il y a une description on la prend sinon on la remplacepar le 1er exemple
          if (lesIntents[n].desc !== '') {
            listExamples = lesIntents[n].desc
          } else {
            listExamples = lesIntents[n].ex[0]
          }

          this.listIntents.push({ text: listExamples,
            value: lesIntents[n].code,
            code: lesIntents[n].code,
            desc: lesIntents[n].desc,
            ex: lesIntents[n].ex,
            botWorkspace: this.botWorkspace
          })
        }
        // console.log('this.listIntents', this.listIntents)
        this.newIntentExemple.ex = this.intentDialog.code
        this.activeIntents = this.listIntents.length
        // classement
        this.classementListeIntents()
        // this.listIntents.sort(function (a, b) {
        //   return a.localeCompare(b)
        // })
      }
    },
    afficheReponseBot () {
      console.log('afficheFirstIntent', this.changeIntent)
      this.isLoading = true
      let dataToPost = new window.FormData()
      // let reponseBot = []
      dataToPost.append('botWorkspace', this.intentDialog.botWorkspace)
      dataToPost.append('codeIntention', '#' + this.changeIntent.code)
      // dataToPost.append('codeIntention', '#tf_qui')
      this.axios.post('get/faq.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.botReponses = []
          // this.resAjx = response.data
          console.log('response.data', response.data)
          if (response.data.length) {
            let lesReponses = JSON.parse(response.data[0].FAQ_INTEND_RESPONSE)
            this.isLoading = false
            console.log(lesReponses)
            console.log(lesReponses.generic.length)
            console.log(lesReponses.generic[0])
            if (lesReponses.generic.length) {
              for (let a in lesReponses.generic) {
                if (lesReponses.generic[a].selection_policy) {
                  if (lesReponses.generic[a].selection_policy === 'random') {
                    this.repBotRandom = true
                  } else {
                    this.repBotRandom = false
                  }
                } else {
                  this.repBotRandom = false
                }
                for (let b in lesReponses.generic[a].values) {
                  this.botReponses.push(lesReponses.generic[a].values[b].text)
                }
              }
            }
            console.log('this.botReponses', this.botReponses)
          } else {
            this.botReponses.push('null') // pas de réponse dispo
          }
        })
        .catch()
    },
    confirmeDialogEdit () {
      this.showDialogConfirmation = true
      this.titleDialogConfirm = this.$t('confirmation')
      if (this.originalIntent === '') {
        if (this.intentToCreate === '' && this.changeIntent === '') {
          this.contentDialogConfirm = this.$t('noChangeIntent')
        } else if (this.changeIntent === '' && this.intentToCreate !== '') {
          this.contentDialogConfirm = 'Vous êtes sur le point de créer une nouvelle intention <b>' + this.intentToCreate + '</b>.<br>Voulez vous continuer ?'
        } else if (this.intentToCreate === '' && this.changeIntent !== '') {
          this.contentDialogConfirm = 'Le message <br><i><b>"' + this.intentDialog.code + '"</b></i><br> va être associé à la connaissance <br><b>"' + this.changeIntent.desc + '"</b>.<br><br>Voulez vous continuer ?'
        }
      }

      if (this.originalIntent !== '') {
        if (this.intentToCreate === '' && this.changeIntent === '') {
          this.contentDialogConfirm = 'Attention, vous êtes sur le point de désattribuer le message <i><b>"' + this.intentDialog.code + '"</b></i> de l\'intention <b>' + this.originalIntent + '</b>.<br>Voulez vous continuer ?'
        } else if (this.intentToCreate === '' && this.changeIntent === this.originalIntent) {
          this.contentDialogConfirm = 'Aucun changement d\'intention effectué. Le message a été marqué comme vu/traité.'
        } else if (this.intentToCreate === '' && this.changeIntent !== this.originalIntent) {
          this.contentDialogConfirm = 'Le message <br><i><b>"' + this.intentDialog.code + '"</b></i><br> va être associé à la connaissance <br><b>"' + this.changeIntent.desc + '"</b>.<br><br>Voulez vous continuer ?'
        } else if (this.changeIntent === '' && this.intentToCreate !== '') {
          this.contentDialogConfirm = 'Vous êtes sur le point de créer une nouvelle intention <b>' + this.intentToCreate + '</b>.<br>Voulez vous continuer ?'
        }
      }
    },
    closeDialogConfirm () {
      // this.$emit('submitUpdate', this.ModifFaqDialog)
      this.showDialogConfirmation = false
    },
    submitDialogConfirm () {
      this.loading = true
      this.showDialogConfirmation = false
      this.loadingModifFAQ = true
      console.log('submitDialogConfirm')
      console.log('this.originalIntent', this.originalIntent)
      console.log('this.changeIntent', this.changeIntent)
      this.samples = []
      // todo test nouvelle intent : nb disponibles, non doublon ,  syntaxe, tester si  l'example existe déjà
      let descOfChosenIntent = '' /* on est obligé de renvoyer la desc initiale */
      for (let n in this.listIntents) {
        if (this.listIntents[n].code === this.changeIntent) {
          descOfChosenIntent = this.listIntents[n].desc
          for (let j in this.listIntents[n].ex) {
            this.samples.push({ content: this.listIntents[n].ex[j] })
          }
        }
      }
      // this.classementListeIntents()
      this.samples.push({ content: this.intentDialog.code })

      let dataToPost = new window.FormData()
      dataToPost.append('user_id', this.$store.state._User.id)
      dataToPost.append('newIntent', this.intentToCreate)
      dataToPost.append('choosenIntent', this.changeIntent.code)
      dataToPost.append('desc', descOfChosenIntent)
      dataToPost.append('origin', this.originalIntent)
      dataToPost.append('samples', JSON.stringify(this.samples))
      dataToPost.append('botWorkspace', this.intentDialog.botWorkspace)
      dataToPost.append('id', this.intentDialog.id)
      this.axios.post('https://public.targetfirst.com/public/ibm/edit_message.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('edit_message.php ', response)
        if (this.changeIntent !== '') {
          this.intentDialog.intent = this.changeIntent
          // this.intentDialog.intent = this.changeIntent.intent
        }

        this.listIntents = []

        let dataPost = new window.FormData()
        dataPost.append('botWorkspace', this.intentDialog.botWorkspace)
        this.axios.post('https://public.targetfirst.com/public/ibm/intents.php', dataPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          console.log('intents.php ', response)
          this.resAjx = response.data
          this.$store.commit('_Sites/SET_INTENTS', this.resAjx)
        })
        .then(_ => {
          for (let n in this.resAjx) {
            // let listExamples = ' ('
            // let comptEx = 0
            // for (let j in this.resAjx[n].ex) {
            //   if (comptEx < 2) {
            //     listExamples += this.resAjx[n].ex[j] + ' ; '
            //   }
            //   comptEx++
            // }
            // listExamples += ')'
            this.listIntents.push({ text: '#' + this.resAjx[n].code,
              value: this.resAjx[n].code,
              code: this.resAjx[n].code,
              desc: this.resAjx[n].desc,
              ex: this.resAjx[n].ex,
              botWorkspace: this.botWorkspace
            })
          }
          // this.classementListeIntents()
          // window.location.reload()
        })
        // classement
        // this.listIntents.sort(function (a, b) {
        //   return a.localeCompare(b)
        // })
        this.classementListeIntents()
        // console.log('this.listIntents', this.listIntents)

        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })

        this.$emit('messageIsTreated', this.intentDialog.id)
        let newOrExisting = this.changeIntent !== '' ? this.changeIntent : this.intentToCreate
        this.$emit('newIntentformessage', {intendTochange: newOrExisting, id: this.intentDialog.id})

        if (this.intentToCreate !== '' || this.changeIntent !== '') {
          this.$emit('updateIntend')
        }
        this.$emit('updateTraininDate')
        this.$emit('closeDialog')
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
      })
      .then(_ => {
        this.loading = false
        this.loadingModifFAQ = false
      })
    },
    changeSection () {
      this.currentTab = 0
    },
    changeDialogIntent (id) {
      this.$emit('changeDialog', id)
    },
    // ferme la dialogBox de création de nouvelle intention
    closeDialogCreatIntent () {
      this.showDialogCreateIntent = false
    },
    // nouvelle intention crée
    newIntendOK (data) {
      this.intentDialog.intent = data.code
      this.listIntents.push({ text: data.desc,
        value: data.code,
        code: data.code,
        desc: data.desc,
        ex: data.ex,
        botWorkspace: this.botWorkspace
      })
      this.activeIntents = this.listIntents.length
      for (let k in this.listIntents) {
        if (this.intentDialog.intent === this.listIntents[k].code) {
          this.changeIntent = this.listIntents[k]
        }
      }
      // classement
      // this.listIntents.sort(function (a, b) {
      //   return a.localeCompare(b)
      // })
      this.classementListeIntents()
      this.disableValid = true
      this.$emit('updateIntend')

      let dataToPost = new window.FormData()
      dataToPost.append('newIntent', data.code)
      dataToPost.append('botWorkspace', this.intentDialog.botWorkspace)
      dataToPost.append('id', this.intentDialog.id)
      this.axios.post('put/update_message.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(_ => {
        this.$emit('messageIsTreated', this.intentDialog.id)
      })
    },
    // open dialog modif faq
    updateFAQ (data) {
      // this.faqs.push(data)
      // this.classementFAQ()
      // console.log('this.faqs', this.faqs)
      // ferme la dialogbox creation intention
      this.showDialogCreate = false
      // ouvre la dialogbox modification base de connaissance avec la nouvelle intention
      this.openDialogUpdate(data)
    },
    // ouvre le dialogue de modification de la nouvelle faq pour ajouter une réponse
    openDialogUpdate (faq) {
      // console.log('this.faqDialog', this.faqDialog)
      console.log('open update', faq)
      // if (!this.overMenu) {
      this.faqDialog = _.clone(faq)
      this.showDialogUpdate = true
      // }
    },
    addReponses (value) {
      this.faqDialog = value
      console.log('addReponse2', this.faqDialog)
    },
    // retour des données de la dialogBox apres enregistrement
    submitUpdate (value) {
      // console.log('submitUpdate', value)
      // console.log('classement liste intent', this.listIntents)
      // il faut mettre à jour la liste des intention
      let intentionCode = value.intend.replace('#', '')
      let exemples = []
      if (value.output1.text) {
        exemples.push(value.output1.text)
      }
      if (value.output2.text) {
        exemples.push(value.output2.text)
      }
      let newIntention = {
        text: value.desc,
        value: intentionCode,
        code: intentionCode,
        desc: value.desc,
        ex: exemples,
        botWorkspace: this.botWorkspace
      }
      this.listIntents.push(newIntention)
      // classement
      // this.listIntents.sort(function (a, b) {
      //   return a.localeCompare(b)
      // })
      this.classementListeIntents()
      // et selectionner la nouvelle intention
      this.changeIntent = newIntention
      this.faqDialog = _.clone(value) // mise à jour de l'abject
      this.showDialogUpdate = false
    },
    classementListeIntents () {
      // this.listIntents.sort((a, b) => (a.text > b.text) ? 1 : -1)
      // this.listIntents.sort((a, b) => a.text - b.text)
      this.listIntents.sort((a, b) => a.text.localeCompare(b.text))
      // console.log('classement liste intent', this.listIntents)
    }
  },

  watch: {
    intentDialog (val, oldVal) {
      console.log('watch intentDialog', this.intentDialog)
      this.originalIntent = ''
      this.intentToCreate = ''
      this.actualIntent = '-'
      this.blockSelector = false
      this.samples = []
      this.changeIntent = ''
      this.intentDialog.intent ? this.actualIntent = this.intentDialog.intent : this.actualIntent = '-'
      this.originalIntent = this.intentDialog.intent
      this.disableValid = false
      if (this.intentDialog.botWorkspace && this.intentDialog.botWorkspace !== 'undefined') {
        this.initList()
      }
      console.log('this.listIntents', this.listIntents)
      for (let k in this.listIntents) {
        if (this.intentDialog.intent === this.listIntents[k].code) {
          console.log('this.changeIntent', this.changeIntent)
          this.changeIntent = this.listIntents[k]
        }
      }
      this.classementListeIntents()
    },
    intentToCreate (val, oldVal) {
      if (this.intentToCreate === '') {
        this.blockSelector = false
      } else {
        this.blockSelector = true
        this.changeIntent = ''
      }
    },
    search (val) {
      console.log('search', this.changeIntent)
      this.afficheReponseBot()
    },
    changeIntent (val) {
      // this.disableValid = false
    }
  },

  filters: {
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
  .btnIntentBot {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzLearn.vue